import { render, staticRenderFns } from "./CompanyRepxStagesSettings.vue?vue&type=template&id=7131cd88"
import script from "./CompanyRepxStagesSettings.vue?vue&type=script&lang=js"
export * from "./CompanyRepxStagesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7131cd88')) {
      api.createRecord('7131cd88', component.options)
    } else {
      api.reload('7131cd88', component.options)
    }
    module.hot.accept("./CompanyRepxStagesSettings.vue?vue&type=template&id=7131cd88", function () {
      api.rerender('7131cd88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/CompanyRepxStagesSettings.vue"
export default component.exports